import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {PhoneNumbersService} from '../phone-numbers.service';
import {EnableSmsPhoneNumberRequest, SmsAvailablePhoneNumberModel} from 'src/app/api/models';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormFieldFix } from '../../editors/mat-form-field/mat-form-field-fix';
import { MatFormField, MatLabel, MatPrefix, MatError } from '@angular/material/form-field';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatCheckboxInputComponent } from '../../editors/mat-checkbox-input/mat-checkbox-input.component';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';

export interface AddSmsNumberDialogComponentData {
  smsNumberType: 'sms' | 'prosms';
}

interface AddSmsNumberFormModel {
  phoneNumber: FormControl<SmsAvailablePhoneNumberModel>;
  phoneNumberFilter: FormControl<string>;
  receiveEmail: FormControl<boolean>;
  includeText: FormControl<boolean>;
}

@Component({
    selector: 'app-add-sms-number-dialog',
    templateUrl: './add-sms-number-dialog.component.html',
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldFix,
        MatFormField,
        MatLabel,
        MatSelect,
        MatSelectTrigger,
        MatInput,
        MatPrefix,
        NgIf,
        MatOption,
        NgFor,
        MatError,
        MatCheckboxInputComponent,
        MatDialogActions,
        MatButton,
        AsyncPipe,
        PhoneNumberPipe,
    ],
})
export class AddSmsNumberDialogComponent implements OnInit, OnDestroy {

  form: FormGroup<AddSmsNumberFormModel>;
  phoneNumberControl: FormControl = new FormControl<SmsAvailablePhoneNumberModel>(null, [Validators.required]);
  phoneNumberFilterControl: FormControl = new FormControl<string>('', []);
  receiveEmailControl: FormControl = new FormControl<boolean>(false, []);
  includeTextControl: FormControl = new FormControl<boolean>(false, []);

  submitted = false;
  phoneNumbersList: SmsAvailablePhoneNumberModel[] = [];
  filteredPhoneNumbersList: Observable<SmsAvailablePhoneNumberModel[]> = of([]);


  constructor(public dialogRef: MatDialogRef<AddSmsNumberDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: AddSmsNumberDialogComponentData,
              private fb: FormBuilder,
              public phoneNumbersService: PhoneNumbersService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.phoneNumbersService.getSmsAvailablePhoneNumbers({smsType: this.data.smsNumberType}).then((numbers) => {
      this.phoneNumbersList = numbers;

      //this.filteredPhoneNumbersList = of([...numbers]);

      this.filteredPhoneNumbersList = this.phoneNumberFilterControl.valueChanges.pipe(
        startWith(''),
        map(value => this.filterNumbers(value || '')),
      );
    });

    this.receiveEmailControl.valueChanges.subscribe(value => {
      if (!value) {
        this.form.patchValue({
          includeText: false,
        });
      }
    });

    this.includeTextControl.valueChanges.subscribe(value => {
      if (value) {
        this.form.patchValue({
          receiveEmail: true,
        });
      }
    });
  }

  private filterNumbers(value: string): SmsAvailablePhoneNumberModel[] {
    const filterValue = value?.toLowerCase() || '';

    return this.phoneNumbersList.filter(option => option.number.toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
  }

  async onSubmit() {
    this.submitted = false;
    //this.serverError = false;
    this.form.markAllAsTouched();

    if (this.form.valid) {
      this.submitted = true;
      const reqData = this.prepareFormModel();

      try {
        await this.phoneNumbersService.enableSmsNumberForUser(reqData);
        this.dialogRef.close(true);
      } catch (e) {

      } finally {
        this.submitted = false;
      }

      /*if (await this.phoneNumbersService.enableSmsNumberForUser(reqData)) {
        this.notificationService.notifySuccess('Role updated successfully');

        this.ngOnChanges();
        this.headerService.goBack();
      } else {
        this.serverError = true;
      }*/
    }
  }

  prepareFormModel(): EnableSmsPhoneNumberRequest {
    const formModel = this.form.value;

    return {
      smsType: this.data.smsNumberType,
      phoneNumberId: formModel.phoneNumber.id,
      includeText: formModel.includeText,
      receiveEmail: formModel.receiveEmail,
    };
  }

  createForm(): void {
    const controlsConfig: AddSmsNumberFormModel = {
      phoneNumber: this.phoneNumberControl,
      phoneNumberFilter: this.phoneNumberFilterControl,
      receiveEmail: this.receiveEmailControl,
      includeText: this.includeTextControl,
    };

    this.form = this.fb.group(controlsConfig);
  }

  closeDialog() {
    console.log('closeDialog');
    this.dialogRef.close('');
  }
}
